import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import ScenarioPage from "@/pages/Scenario";
import Receipts from "@/pages/Receipts";
import TechLab from "@/pages/TechLab";
import Snapshot from "@/pages/Snapshot";
import Brief from "@/pages/Brief";
import ResponsibleTechnology from "@/pages/ResponsibleTechnology";
import PublicReceipt from "@/pages/PublicReceipt";
import { Toaster } from "@/components/ui/sonner";
import { SectorProvider } from "@/lib/sector";
import { BrandProvider } from "@/lib/brand";

export default function App() {
    return (
        <div className="App min-h-screen flex flex-col bg-white text-slate-900">
            <BrandProvider>
                <SectorProvider>
                    <BrowserRouter>
                        <Header />
                        <main className="flex-1">
                            <Routes>
                                <Route path="/" element={<Landing />} />
                                <Route
                                    path="/scenario/:slug"
                                    element={<ScenarioPage />}
                                />
                                <Route path="/receipts" element={<Receipts />} />
                                <Route path="/tech-lab" element={<TechLab />} />
                                <Route
                                    path="/snapshot/:token"
                                    element={<Snapshot />}
                                />
                                <Route path="/brief/:token" element={<Brief />} />
                                <Route
                                    path="/responsible-technology"
                                    element={<ResponsibleTechnology />}
                                />
                                <Route path="/r/:hash" element={<PublicReceipt />} />
                            </Routes>
                        </main>
                        <Footer />
                    </BrowserRouter>
                </SectorProvider>
            </BrandProvider>
            <Toaster />
        </div>
    );
}
